import React, { Component } from 'react';
import ReactModal from 'react-modal';
import PropTypes from 'prop-types';
import Icon from 'Components/Icon';
import { classnames } from 'Utils/classnames';

ReactModal.setAppElement('#root');

class BetslipModal extends Component {
  static defaultProps = {
    onOpen: null,
    showClose: true,
    overlayClick: true,
    isOpen: true,
    overlayStyle: {},
    contentStyle: {},
  };

  static propTypes = {
    className: PropTypes.string,
    contentClass: PropTypes.string,
    isOpen: PropTypes.bool,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    showClose: PropTypes.bool,
    overlayClick: PropTypes.bool,
    children: PropTypes.node,
    title: PropTypes.string,
    iconName: PropTypes.string,
    type: PropTypes.oneOf(['success', 'error', 'waiting']),
    fullScreenHeaderTitle: PropTypes.string,
    overlayStyle: PropTypes.object,
    contentStyle: PropTypes.object,
  };

  render () {
    const {
      className,
      onOpen,
      onClose,
      showClose,
      overlayClick,
      children,
      title,
      iconName,
      isOpen,
      type,
      contentClass = '',
      fullScreenHeaderTitle,
    } = this.props;
    const btnClose
      = showClose === true ? (
        <div className="modal__close" onClick={ onClose }>
          <Icon iconName="svgCloseDelete" />
        </div>
      ) : null;
    const modalTitle = title ? (
      <div className="modal__title">{ title }</div>
    ) : null;

    const modalIcon = iconName && (
      <div className="modal__container">
        <Icon className="modal__container__icon" iconName={ iconName }  />
      </div>
    );

    const modalContentClass = classnames({
      modal__content: true,
      [contentClass]: !!contentClass
    });

    return (
      <ReactModal
        isOpen={ isOpen }
        onAfterOpen={ onOpen }
        onRequestClose={ onClose }
        shouldCloseOnOverlayClick={ overlayClick }
        contentLabel="Modal"
        className={ classnames({
          modal: true,
          [className]: className,
          'modal--success': type === 'success',
          'modal--error': type === 'error',
          'modal--waiting': type === 'waiting'
        }) }
        overlayClassName="modal-overlay"
        portalClassName="modal-portal"
        bodyOpenClassName="modal-open-body"
        htmlOpenClassName="modal-open-html"
        style={ {
          overlay: {
            ...this.props.overlayStyle
          },
          content: {
            ...this.props.contentStyle
          }
        } }
      >
        { btnClose }

        { fullScreenHeaderTitle ? <div className='modal__fullscreen-header'>
          { fullScreenHeaderTitle }
          <div className='modal__fullscreen-close' onClick={ onClose }>
            <Icon iconName="svgCloseDelete" />
          </div>
        </div> : null }
        <div className={ modalContentClass } >
          { modalIcon }

          { modalTitle }

          { children }
        </div>
      </ReactModal>
    );
  }
}

export default BetslipModal;

